import AINavigator from './AINavigator';

export default AINavigator;